import { AfterViewInit, OnDestroy, ViewChild } from '@angular/core'
import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { Subscription } from 'rxjs'
import { LauncherInfo } from 'src/api/launcher-api/launcher-api.interface'
import { LaunchersService } from 'src/api/launcher-api/launcher-api.service'
import { AuthService } from 'src/app/components/isbeauth/auth.service'
import { NotificationItem, NotificationFile } from 'src/app/components/nav/nav-menu.interface'
import { ImportantNoticeSetting, NavService } from 'src/app/components/nav/nav.service'
import { ImportantNoticePopupComponent } from 'src/app/module/common-parts/important-notice-popup/important-notice-popup.component'


@Component({
  selector: 'app-myidea-top',
  templateUrl: './myidea-top.component.html',
  styleUrls: ['./myidea-top.component.scss']
})
export class MyideaTopComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild('noticePopup') noticePopupComponent: ImportantNoticePopupComponent

  launchers: LauncherInfo[]
  personalNotificationList: NotificationItem[] = []
  overAllNotificationList: NotificationFile[] = []

  subscription: Subscription
  public viewCd = 'myidea-top'
  constructor(
    private authService: AuthService,
    private launchersService: LaunchersService,
    private navService: NavService,
    private router: Router
  ) {}

  async ngOnInit(): Promise<void> {
    this.getLauncherInfo()
    const s = this
    s.personalNotificationList = s.navService.getPersonalAlertAction
    s.subscription = s.navService.personalNotificationListInfoSource$.subscribe((list) => {
      s.personalNotificationList = list
    })
    // TBSNo.	485 お知らせの提示改善対応
    s.subscription = s.navService.importantNoticeInfoSource$.subscribe((data) => {
      // 通知データを更新してから重要なお知らせ表示チェック
      this.checkImportantNotice()
    })
    this.checkImportantNotice()
  }

  ngAfterViewInit(): void {}

  public ngOnDestroy(): void {
    this.subscription?.unsubscribe()
  }

  // ランチャー(製品リンク)情報取得
  async getLauncherInfo(): Promise<void> {
    const customerCd = this.authService.AccountInfo?.customerCd
    if (!customerCd) {
      return
    }
    const ret = await this.launchersService.GetLauncherInfo(customerCd)
    if (ret?.resultCode !== 0) {
      return
    }
    this.launchers = ret.data
  }

  getLauncherLogo(launcherInfo: LauncherInfo): string {
    if (launcherInfo.serviceCd === 'core.frimo') {
      return '/assets/images/common/frimo_logo.png'
    }
    if (launcherInfo.serviceCd === 'pic.frimo') {
      return '/assets/images/common/web-pack_logo.png'
    }
    if (launcherInfo.serviceCd === 'core.p-garage') {
      return '/assets/images/common/garage_logo.png'
    }
    if (launcherInfo.serviceCd === 'healthCheckup') {
      return '/assets/images/common/healthCheckup_logo.png'
    }
    if (launcherInfo.serviceCd === 'micom_s') {
      return '/assets/images/common/logo_micomel_shimamura_y.png'
    }
    return ''
  }

  serviceLink(launcherInfo: LauncherInfo): void {
    if (launcherInfo.isRelease && launcherInfo.isUser) {
      const token = this.authService.AccountInfo.token
      let tmpToken = null
      let u1 = null
      let u2 = null
      let url = launcherInfo.serviceUrl
      let i = url.indexOf('#')
      if (i !== -1) {
        u1 = url.substring(0, i)
        u2 = url.substring(i)
        tmpToken = `${u1}?token=${token}${u2}`
      }
      if (tmpToken == null) {
        tmpToken = `${url}?token=${token}`
      }
      window.location.href = tmpToken
    }
  }

  notificationLink(path: string): void {
    if (path?.startsWith('http')) {
      window.open(path, '_blank')
    } else {
      this.router.navigate([path])
    }
  }

  // TBSNo.	485 お知らせの提示改善対応
  // 重要なお知らせボタンのナビゲーション
  navigateToImportantNotice(): void {
    if (this.notificationData.showPopupOnTopPage && this.noticePopupComponent) {
      // 重要なお知らせポップアップを表示
      this.noticePopupComponent.show()
    } else {
      // 直接リンク先を開く
      this.notificationLink(this.notificationData.linkUrl)
    }
  }

  navigateToIdea(): void {
    this.notificationLink('https://idea-place.jp/')
  }

  navigateToPetaboInformation(): void {
    this.router.navigate(['/information'])
  }

  navigateToPetaboVideo(): void {
    this.router.navigate(['/video'])
  }

  enableIdeaBtn = false
  notificationData: ImportantNoticeSetting = null
  actionTransactionCommandCd: string = ''
  popupActionTransactionViewCd: string = '' // ポップアップ側でトランザクションを記録する場合のみセット

  // 重要なお知らせボタン表示チェック
  checkImportantNotice(): void {
    this.enableIdeaBtn = false
    const notificationData = this.navService.getImportantNoticeAction
    if (notificationData === undefined) {
      return
    }
    this.notificationData = notificationData
    this.setActionTransactionCommandCd()
    if (!this.notificationData) {
      this.enableIdeaBtn = true
    }
  }

  // actionTransactionのクリックイベントを設定する
  private setActionTransactionCommandCd(): void {
    if (!this.notificationData?.actionTransactionKey) {
      return
    }
    // TOPページでポップアップを開く場合
    if (this.notificationData.showPopupOnTopPage) {
      this.popupActionTransactionViewCd = this.viewCd
    } else {
      let key = this.notificationData.actionTransactionKey
      // keyの中の{viewCd}となっている部分を置換
      key = key.replace('{viewCd}', this.viewCd)
      this.actionTransactionCommandCd = key
    }
  }
}
